// DEPRECATED import from ./string instead
import {titleize} from './string'

export default titleize